import { css } from '@emotion/core';
import { variables, tokens } from '@domain-group/fe-brary';
var colour = variables.colour,
  font = variables.font;
var colors = tokens.colors;
export var container = {
  name: "wi7065",
  styles: "position:relative;min-height:64px;"
};
export var arrowIcon = {
  name: "1phwv1s",
  styles: "display:block;width:18px;height:18px;"
};
export var nameIcon = {
  name: "xp9nd7",
  styles: "position:absolute;right:20px;top:12px;"
};
export var nameContainer = /*#__PURE__*/css("width:100%;background-color:transparent;text-align:left;border:0;outline:0;font-family:", font.bodyFontFamily, ";font-size:", font.baseMobileFontSize, ";font-weight:600;color:", colors.neutral.heavy.default, ";padding:0 16px;");
export var nameLabel = isButtonStyle => /*#__PURE__*/css("display:inline-block;padding-top:8px;cursor:pointer;", isButtonStyle && /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";padding-top:16px;height:64px;"));
export var summary = /*#__PURE__*/css("font-family:", font.bodyFontFamily, ";font-size:", font.smallMobileFontSize, ";font-weight:normal;color:", colour.neutral400, ";padding:0 16px;");
export var sliderBody = {
  name: "172k2rp",
  styles: "transition-duration:0.2s;transition-timing-function:ease-in-out;"
};
export var sliderContent = {
  name: "1w0ym84",
  styles: "padding:8px 0;"
};
export var global = {
  name: "v3qt3a",
  styles: ".react-slidedown{height:0;transition-property:none;transition-duration:0.5s;transition-timing-function:ease-in-out;}.react-slidedown.transitioning{overflow-y:hidden;}.react-slidedown.closed{display:none;}"
};